
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { BonusVO } from "../../../gamevo/BonusVO";
import { BonusVOParseHelper } from "../../../model/helper/BonusVOParseHelper";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2LoginBonusDialog } from "../../../view/dialogs/login/Poker2LoginBonusDialog";
import { Poker2LoginBonusDialogProperties } from "../../../view/dialogs/login/Poker2LoginBonusDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class GDBCommand extends Poker2Command {
    protected get cmdId(): string {
        return "gdb";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            if (!paramObj)
                return true;
            if (this.layoutManager.inGameState) {
                var bonusVOs: BonusVO[] = BonusVOParseHelper.parseBonusVOs(paramObj);
                if (bonusVOs) {
                    this.layoutManager.showDialog("Poker2LoginBonusDialog", new Poker2LoginBonusDialogProperties(paramObj.day, bonusVOs));
                }
            }
            else
                Poker2Model.sessionData.addInGameCommand(this.cmdId, paramObj);

            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
